import React from 'react';
import PropTypes from 'prop-types';

import ProductPropertyTab, { PropertyList } from '../../molecules/product-detail-accordion';

const FullListIngredients = ({ product, ingredients }) => (
  (ingredients && ingredients.length > 0) ? (
    <ProductPropertyTab title="Full list of ingredients" product={product}>
      <PropertyList element="ul" like="dec-4">
        {
          ingredients.map(({ value }) => (
            <li key={value}>{value}</li>
          ))
        }
      </PropertyList>
    </ProductPropertyTab>
  ) : null);

FullListIngredients.defaultProps = {
  ingredients: []
};

FullListIngredients.propTypes = {
  product: PropTypes.object.isRequired,
  ingredients: PropTypes.array
};

export default FullListIngredients;
